import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Loader from '../Components/Loader';
import ExcelJS from 'exceljs';
import IAOfficersInfoModal from './iaOfficersInfoModal';
import IAOfficersAdd from './IAOfficersAdd';
import IAOfficersEdit from './IAOfficersEdit';

/* global showSaveFilePicker */

const mockData = [
  {
    id: 1,
    last_name: 'Ledesma',
    first_name: 'Heart Key',
    middle_name: 'N/A',
    phone_number: '09123456789',
    email: 'heart.ledesma@example.com',
    address: 'Centro 7, Zamora, Bilir, Bohol',
    date_of_birth: '14/02/05',
    name_of_spouse: 'Gwansik L. Ambe',
    position: 'Staff',
    appointment_year: '2023',
    tin: '84785634789',
    motto: 'Lead with purpose',
  },
  {
    id: 2,
    last_name: 'Smith',
    first_name: 'Mary',
    middle_name: 'B',
    phone_number: '987-654-3210',
    email: 'mary.smith@example.com',
    address: '456 Oak Ave, Town',
    date_of_birth: '02/15/75',
    name_of_spouse: 'James Smith',
    position: 'Treasurer',
    appointment_year: '2024',
    tin: '987-65-4321',
    motto: 'Serve with dedication',
  },
];

const IAOfficers = ({ darkMode, onBack }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [loading] = useState(false);
  const [error] = useState(null);
  const [showSuccess, setShowSuccess] = useState(false);
  const [activeForm, setActiveForm] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);

  const filteredData = mockData.filter(item =>
    (item.last_name?.toLowerCase() || '').includes(searchQuery.toLowerCase()) ||
    (item.first_name?.toLowerCase() || '').includes(searchQuery.toLowerCase()) ||
    (item.position?.toLowerCase() || '').includes(searchQuery.toLowerCase())
  );

  const openAddForm = () => {
    setActiveForm('add');
    setSelectedRow(null);
  };

  const openEditForm = (item) => {
    setSelectedRow(item);
    setActiveForm('edit');
  };

  const closeForm = () => {
    setActiveForm(null);
    setSelectedRow(null);
  };

  const handleExport = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('IAOfficers');

    worksheet.mergeCells('A1:M1');
    const titleCell = worksheet.getCell('A1');
    titleCell.value = 'UNITED LAT B3 IA OFFICERS';
    titleCell.font = { name: 'Calibri', size: 20, bold: true };
    titleCell.alignment = { horizontal: 'left', vertical: 'middle' };
    worksheet.addRow([]);

    const headerRow = [
      'No', 'Last Name', 'First Name', 'Middle Name', 'Phone Number', 'Email', 'Address',
      'Date Of Birth mm/dd/yy', 'Name Of Spouse', 'Position', 'Appointment Year', 'Tin', 'Motto'
    ];
    worksheet.addRow(headerRow);

    const headerRowNumber = 3;
    worksheet.getRow(headerRowNumber).eachCell(cell => {
      cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '2E7D32' } };
      cell.alignment = { horizontal: 'left', wrapText: true };
      cell.border = {
        top: { style: 'thin', color: { argb: '000000' } },
        bottom: { style: 'thin', color: { argb: '000000' } },
        left: { style: 'thin', color: { argb: '000000' } },
        right: { style: 'thin', color: { argb: '000000' } },
      };
    });

    filteredData.forEach((item, index) => {
      const row = worksheet.addRow([
        index + 1,
        item.last_name,
        item.first_name,
        item.middle_name,
        item.phone_number,
        item.email,
        item.address,
        item.date_of_birth,
        item.name_of_spouse,
        item.position,
        item.appointment_year,
        item.tin,
        item.motto,
      ]);

      row.eachCell((cell, colNumber) => {
        cell.border = {
          top: { style: 'thin', color: { argb: '000000' } },
          bottom: { style: 'thin', color: { argb: '000000' } },
          left: { style: 'thin', color: { argb: '000000' } },
          right: { style: 'thin', color: { argb: '000000' } },
        };
        cell.alignment = {
          horizontal: 'left',
          vertical: 'top',
          wrapText: true,
        };
      });
    });

    worksheet.columns = [
      { key: 'no', width: 5 },
      { key: 'last_name', width: 15 },
      { key: 'first_name', width: 15 },
      { key: 'middle_name', width: 15 },
      { key: 'phone_number', width: 15 },
      { key: 'email', width: 25 },
      { key: 'address', width: 30 },
      { key: 'date_of_birth', width: 15 },
      { key: 'name_of_spouse', width: 20 },
      { key: 'position', width: 15 },
      { key: 'appointment_year', width: 15 },
      { key: 'tin', width: 15 },
      { key: 'motto', width: 20 },
    ];

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    if (window.isSecureContext && 'showSaveFilePicker' in window) {
      try {
        const options = {
          suggestedName: 'IAOfficers.xlsx',
          types: [{
            description: 'Excel File',
            accept: { 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'] }
          }]
        };
        const handle = await showSaveFilePicker(options);
        const writable = await handle.createWritable();
        await writable.write(blob);
        await writable.close();
        setShowSuccess(true);
      } catch (err) {
        console.error('Error saving file:', err.name, err.message || err);
        if (err.name !== 'AbortError') {
          alert('Save failed due to an unexpected error. Check the console.');
        }
      }
    } else {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'IAOfficers.xlsx';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
      setShowSuccess(true);
    }
  };

  useEffect(() => {
    if (showSuccess) {
      const timer = setTimeout(() => {
        setShowSuccess(false);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [showSuccess]);

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: darkMode ? '#1a1a1a' : '#ffffff',
      }}>
        <Loader />
      </div>
    );
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  return (
    <Container>
       <BackButton onClick={onBack}>‹</BackButton>
      <Header>
        <Title>UNITED LAT B3 IA OFFICERS</Title>
        <Actions>
          <SearchContainer>
            <SearchInput
              type="text"
              placeholder="Search..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </SearchContainer>
          <ButtonGroup>
            <Button darkMode={darkMode} onClick={openAddForm}>
              IA Profiling Form
            </Button>
            <Button darkMode={darkMode} onClick={handleExport}>Export</Button>
          </ButtonGroup>
        </Actions>
      </Header>
      <Content>
        <TableWrapper>
          <StyledTable darkMode={darkMode}>
            <thead>
              <tr>
                <th>No</th>
                <th>Last Name</th>
                <th>First Name</th>
                <th>Middle Name</th>
                <th>Phone Number</th>
                <th>Email</th>
                <th>Address</th>
                <th>Date Of Birth mm/dd/yy</th>
                <th>Name Of Spouse</th>
                <th>Position</th>
                <th>Appointment Year</th>
                <th>Tin</th>
                <th>Motto</th>
              </tr>
            </thead>
            <tbody>
              {filteredData.map((item, index) => (
                <tr key={item.id} onClick={() => openEditForm(item)}>
                  <td>{index + 1}</td>
                  <td>{item.last_name}</td>
                  <td>{item.first_name}</td>
                  <td>{item.middle_name}</td>
                  <td>{item.phone_number}</td>
                  <td>{item.email}</td>
                  <td>{item.address}</td>
                  <td>{item.date_of_birth}</td>
                  <td>{item.name_of_spouse}</td>
                  <td>{item.position}</td>
                  <td>{item.appointment_year}</td>
                  <td>{item.tin}</td>
                  <td>{item.motto}</td>
                </tr>
              ))}
            </tbody>
          </StyledTable>
        </TableWrapper>
        {activeForm === 'add' && <IAOfficersAdd darkMode={darkMode} onClose={closeForm} />}
        {activeForm === 'edit' && selectedRow && (
          <IAOfficersEdit darkMode={darkMode} data={selectedRow} onClose={closeForm} />
        )}
        {showSuccess && (
          <SuccessMessageContainer darkMode={darkMode}>
            <SuccessMessageText>File saved successfully!</SuccessMessageText>
          </SuccessMessageContainer>
        )}
      </Content>
    </Container>
  );
};

export default IAOfficers;

const Container = styled.div`
  padding: 80px 20px 20px;
  font-family: sans-serif;
  min-height: 100vh;
  box-sizing: border-box;
  background-color: ${props => (props.darkMode ? '#1a1a1a' : '#ffffff')};
`;

const Content = styled.div`
  display: flex;
  gap: 20px;
`;

const TableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
`;

const BackButton = styled.button`
  position: absolute;
  top: 50px;
  left: 85px;
  background: transparent;
  border: none;
  font-size: 28px;
  font-weight: 900;
  cursor: pointer;
  color: ${({ darkMode }) => (darkMode ? '#fff' : '#2e7d32')};
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 15px;
  margin-bottom: 15px;
`;

const Title = styled.h2`
  font-size: 18px;
  font-weight: bold;
  color: #333333;
`;

const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const SearchContainer = styled.div`
  flex: 1;
  margin: 0 20px;
`;

const SearchInput = styled.input`
  padding: 6px 10px;
  font-size: 14px;
  width: 600px;
  border: 1px solid #ccc;
  border-radius: 4px;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 10px;
`;

const Button = styled.button`
  padding: 6px 10px;
  background-color: ${({ darkMode }) => (darkMode ? '#4caf50' : '#4caf50')};
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  &:hover {
    background-color: ${({ darkMode }) => (darkMode ? '#388e3c' : '#388e3c')};
  }
`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  background-color: ${props => (props.darkMode ? '#1a1a1a' : '#ffffff')};
  th {
    background-color: #2e7d32;
    color: white;
    padding: 10px;
    font-size: 14px;
    border: 1px solid #dddddd;
  }
  td {
    padding: 10px;
    font-size: 14px;
    border: 1px solid #ddd;
    white-space: pre-wrap;
    word-wrap: break-word;
    color: ${props => (props.darkMode ? '#ffffff' : '#333333')};
    &:first-child {
      color: ${props => (props.darkMode ? '#00ff00' : '#006400')};
    }
  }
  tbody tr:nth-child(even) {
    background-color: ${props => (props.darkMode ? '#2a2a2a' : '#f9f9f9')};
  }
  tbody tr:hover {
    background-color: ${props => (props.darkMode ? '#333333' : '#f1f1f1')};
  }
`;

const SuccessMessageContainer = styled.div`
  position: absolute;
  bottom: 20px;
  right: 0;
  width: 20%;
  background-color: ${props => (props.darkMode ? '#2e7d32' : '#4CAF50')};
  color: #ffffff;
  padding: 10px 20px;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  z-index: 1000;
  animation: slideIn 0.3s ease-in, slideOut 0.3s ease-in 2.7s;
  @keyframes slideIn {
    from { transform: translateX(100%); }
    to { transform: translateX(0); }
  }
  @keyframes slideOut {
    from { transform: translateX(0); }
    to { transform: translateX(100%); }
  }
`;

const SuccessMessageText = styled.p`
  margin: 0;
  font-size: 16px;
  font-family: Arial, sans-serif;
`;